module.exports = __webpack_public_path__ + "static/media/Team 15 Gone Virtual Logo - Cecilia Ruiz Davila.ac33056f.png";